(function ManagerReservationSearchForm($, HE)
{
	"use strict";

	var form = {
		name: 'ReservationSearch',
	};

	$(document).ready(function documentReady()
	{
		HE.Form.registerForm(form);
	});

	form.load = function load($form)
	{
		/** 
		HE.Typeahead(
			'.existing-customer-search',
			'/Customers/search',
			function selectCustomer(item, $self, typeahead) {
				typeahead.setHiddenValue(item.id);
			}
		);
		**/
	};
}(jQuery, window.HE || {}));